export const allPrograms = ({allPrograms, selectedDay}) => {
  if (!selectedDay) {
    return []
  }
  let dayPrograms = allPrograms.find((i) => i.dayName.toLowerCase() === selectedDay.toLowerCase())
  return dayPrograms.programs
}

export const allDays = ({allPrograms}) => {
  let allDays = []
  allPrograms.forEach((programs) => {
    allDays.push({
      dayName: programs.dayName
    })
  })
  return allDays
}

export const selectedDay = ({selectedDay}) => selectedDay



// WEBPACK FOOTER //
// ./src/app/config/store/modules/programs/getters.js